/**
 * @generated SignedSource<<51074ce54f44e5357673995aba43b062>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type BookingDetailsView_Booking$data = {
  readonly id: string;
  readonly notesFromMember: string | null | undefined;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly facility: {
        readonly type: FacilityType;
      };
    };
  } | null | undefined;
  readonly type: BookingType;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyPunchPassModalContent_Booking" | "BookingActionsSection_Booking" | "CancelBookingButton_Booking" | "EditBookingButton_Booking" | "MoveBookingButton_Booking" | "RecurringRequestSeriesCard_booking" | "RequestDetails_booking" | "RoundList_Booking" | "useGetBookingRestrictionStatusesFragment" | "useGetSummaryCalculations_Booking" | "useIsAnyDynamicRateOnBookingLocked_Booking" | "useIsViewMoreVisible_Booking" | "useRecurringRequestSeriesPreview_booking" | "useRequestRestrictionStatuses_booking" | "useShouldPresentBookingAsLockedRequest_booking">;
  readonly " $fragmentType": "BookingDetailsView_Booking";
};
export type BookingDetailsView_Booking$key = {
  readonly " $data"?: BookingDetailsView_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingDetailsView_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingDetailsView_Booking",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesFromMember",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingRestrictionStatusesFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoveBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditBookingButton_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingActionsSection_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsViewMoreVisible_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestDetails_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecurringRequestSeriesCard_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRecurringRequestSeriesPreview_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRequestRestrictionStatuses_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsAnyDynamicRateOnBookingLocked_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldPresentBookingAsLockedRequest_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoundList_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetSummaryCalculations_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyPunchPassModalContent_Booking"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "41d2eb186c823b0f92fc05ecce6cb18e";

export default node;
